import { FC } from 'react';
import { ActionBlockTypeProps } from './TypeProps';
import { MyLink, LinkTheme } from '@app/shared';
import classNames from 'classnames';

import styles from './ActionBlock.module.scss';

export const ActionBlock: FC<ActionBlockTypeProps> = ({ className, code, name, shortName }) => {
  return (
    <MyLink themes={LinkTheme.Theme7} className={classNames(styles.WrapperActionBlock, className)} href={code}>
      {shortName || name}
    </MyLink>
  );
};
